import { useTranslation } from 'react-i18next';

import { Button } from '@components/Button';
import Modal, { IconBlock, Title } from '@components/Modal';

import styles from './PrintProcessingModal.module.scss';

const languageNamespace = 'printing-modals';

interface PrintProcessingModalProps {
  onCancel?: () => void;
}

export const PrintProcessingModal = ({ onCancel }: PrintProcessingModalProps) => {
  const { t } = useTranslation(languageNamespace);

  return (
    <Modal minWidth="45rem">
      <IconBlock icon="printIcon" />
      <Title title={t('printing')} titleWeight="bolder" />
      {!!onCancel && (
        <Button
          onClick={onCancel}
          text={t('cancelPrint')}
          appearance="text"
          className={styles.cancelButton}
        />
      )}
    </Modal>
  );
};
